export default {
feedback: {
  title: "Feedback",
  placeholder: "Mag-iwan ng mensahe ({ contentLen }/1000 karakter)",
  error: "Ito ay mensahe ng error",
  uploadLimit: "Limitasyon sa pag-upload ng larawan at video",
  send: "Ipadala",
  tipTitle: "Tulungan kaming mapabuti ang iyong karanasan",
  desc1: "Maaari kang magsumite ng anumang tanong, at kung ito ay matanggap, makakatanggap ka ng surprise gift.",
  desc2: "Kung hindi maginhawa sa website, maaari mo rin itong ipadala sa aming email."
}
};
